import { parseISO } from 'date-fns';

const parseDateForPicker = (date: string | null | undefined): Date | null => {
  if (date == null || date === '') {
    return null;
  }
  return parseISO(date);
};

export { parseDateForPicker };
